export default "__VITE_ASSET__CXpR_kho__"